// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import locizer from "locizer";
import Vue from "vue";
import VueI18n from "vue-i18n";

const fallbackLocale = "en";
const PROJECTID = "47589fa6-68de-4d03-a22a-47a3d846bf69";
const NAMESPACE = "frontend";

Vue.use(VueI18n);

export default function (): Promise<VueI18n> {
  return new Promise((resolve, reject) => {
    locizer
      .init({
        fallbackLng: fallbackLocale,
        referenceLng: fallbackLocale,
        projectId: PROJECTID,
      })
      .load(NAMESPACE, (err: any, translations: Record<string, string>, detectedLng: string) => {
        if (err) reject(err);
        resolve(
          new VueI18n({
            locale: fallbackLocale,
            fallbackLocale,
            messages: {
              [detectedLng]: translations,
            },
          }),
        );
      });
  });
}
